<div class="mb-8 p-6 animate-pulse">
    <div class="max-w-3xl mx-auto">
        <div class="min-h-[70vh] mb-12 pt-4 flex flex-col gap-4 justify-between">
            <div class="flex flex-col gap-4">
                <div class="h-8 w-48 bg-light-bgHoverColor  dark:bg-dark-bgHoverColor  rounded"></div>

                <div class="flex flex-col gap-4 mt-6">
                    @for (_ of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track $index) {
                        <div>
                            <div class="h-5 bg-light-bgHoverColor dark:bg-dark-bgHoverColor rounded w-1/3 mb-1 animate-pulse"></div>
                            <div class="mt-1 h-[42px] bg-light-bgHoverColor dark:bg-dark-bgHoverColor rounded w-full animate-pulse"></div>
                        </div>
                    }
                </div>
            </div>

            <div class="flex gap-4 items-center justify-end">
                <div class="h-10 w-28 bg-light-bgHoverColor dark:bg-dark-bgHoverColor rounded"></div>

                <div class="h-10 w-28 bg-light-bgHoverColor dark:bg-dark-bgHoverColor rounded"></div>
            </div>
        </div>
    </div>
</div>
